  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
      <b-row>
        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="evento"
            rules="required"
          >
            <b-form-group label="Evento" label-for="evento">
              <v-select
                id="evento"
                v-model="eventParticipant.evento"
                data-cy="select-evento"
                :options="eventos"
                label="nome"
                :reduce="(evento) => evento"
                placeholder="Selecione o evento"
                :disabled="!canEditOrInsert"
              >
                <template #no-options>
                  <div class="text-muted">Nenhum evento encontrado</div>
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="registro"
            rules="required"
          >
            <b-form-group label="Registro" label-for="registro">
              <v-select
                id="registro"
                v-model="eventParticipant.registro"
                data-cy="select-registro"
                :options="registros"
                label="nome"
                :reduce="(reg) => reg"
                placeholder="Selecione o registro"
                :disabled="!canEditOrInsert"
              >
                <template #no-options>
                  <div class="text-muted">Nenhum registro encontrado</div>
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="data de inscrição"
            rules="required"
          >
            <b-form-group label="Data de Inscrição" label-for="inscritoEm">
              <flat-pickr
                id="inscritoEm"
                v-model="eventParticipant.inscritoEm"
                data-cy="input-inscrito-em"
                class="form-control"
                :config="dateTimeConfig"
                placeholder="Selecione a data de inscrição"
                :disabled="!canEditOrInsert"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <ButtonsFormVue
          :permission-insert="verificarPermissao('ROLE_EVENTOS_INSERIR')"
          :permission-edit="verificarPermissao('ROLE_EVENTOS_ATUALIZAR')"
          :disable-form="false"
          @save="save"
          @cancel="cancel"
        />
      </b-row>
    </b-form>
  </validation-observer>
</b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BFormGroup, BCard, BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'

export default {
  name: 'EventParticipantForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BForm,
    vSelect,
    flatPickr,
    ButtonsFormVue,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Participantes de Evento',
      required,
      dateTimeConfig: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true,
        locale: 'pt',
      },
      eventos: [],
      registros: [],
    }
  },
  computed: {
    ...mapState('eventParticipantSettingsModule', {
      eventParticipant: state => state.eventParticipant,
    }),
    canEditOrInsert() {
      return (
        (!this.eventParticipant.id
          && this.verificarPermissao('ROLE_EVENTOS_INSERIR'))
        || (this.eventParticipant.id
          && this.verificarPermissao('ROLE_EVENTOS_ATUALIZAR'))
      )
    },
  },
  created() {
    this.loadDependencies()
  },
  methods: {
    async loadDependencies() {
      try {
        const queryParams = {
          page: 1, size: 1000, sort: 'nome', order: 'asc',
        }

        // Load Events
        this.$store.dispatch('eventSettingsModule/loadTable', queryParams)
          .then(result => {
            this.eventos = result.data.content
          })

        // Load Registries (Socios)
        this.$store.dispatch('combosModule/loadComboRegisterSocios', '')
          .then(result => {
            this.registros = result.data.content
          })
      } catch (error) {
        console.error('Error loading dependencies:', error)
      }
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          const payload = {
            ...this.eventParticipant,
            evento: { id: this.eventParticipant.evento?.id },
            registro: { id: this.eventParticipant.registro?.id },
          }

          const action = this.eventParticipant.id ? 'edit' : 'insertNew'
          this.$store
            .dispatch(`eventParticipantSettingsModule/${action}`, payload)
            .then(response => {
              if (response.response) {
                this.MensagemError(
                  this.eventParticipant.id
                    ? 'Falha ao Editar'
                    : 'Falha ao Inserir',
                  response.response.data.error,
                )
                return
              }
              this.showMessageSuccess(
                this.eventParticipant.id ? 'Editar' : 'Salvo',
                this.eventParticipant.id
                  ? 'Editado com sucesso!'
                  : 'Incluído com sucesso!',
              )
              this.cancel()
            })
        }
      })
    },
    cancel() {
      this.$emit('cancelar')
      this.$store.dispatch('eventParticipantSettingsModule/reset')
    },
  },
}
</script>
